import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Button, Icon } from '@ibk/shared-ui';
import styles from './BeneficiaryEmptyState.module.css';
export const BeneficiaryEmptyState = ({ hasFilters, onClearFilters, className, filteredTitle, filteredDescription, variant = 'default', }) => {
    const { t } = useTranslation();
    const isCollaborators = variant === 'collaborators';
    const title = hasFilters
        ? (filteredTitle ?? t('benefits.beneficiaries.empty.filtered'))
        : t('benefits.beneficiaries.empty.none');
    const description = hasFilters
        ? (filteredDescription ?? t('benefits.beneficiaries.empty.filtered-description'))
        : t('benefits.beneficiaries.empty.none-description');
    return (_jsxs("div", { className: `${styles.container} ${isCollaborators ? styles.collaboratorsContainer : ''} ${className || ''}`, children: [_jsx(Icon, { name: isCollaborators ? 'bigBlockCircle' : 'users', className: styles.icon }), _jsx("h3", { className: styles.title, children: title }), _jsx("p", { className: styles.description, children: description }), hasFilters && !isCollaborators && (_jsx(Button, { onClick: onClearFilters, variant: 'secondary', size: 'medium', dataTestId: 'clear-filters-button', className: styles.button, children: t('benefits.beneficiaries.clear-filters') }))] }));
};
